module.exports = __webpack_public_path__ + "img/discord.a2744d1d.svg";